module.exports = __webpack_public_path__ + "static/media/alarm-bell-sleep-1.5a1881f7.svg";